import { FunctionComponent } from 'react';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import styles from './ViewEvaluationReportHeader.module.scss';

// UI Components
import Button from 'components/UI/V3/Button/Button';

export interface ViewEvaluationReportHeaderProps {
    title: string;
    onBack?: () => void;
    onEdit?: () => void;
}

export const ViewEvaluationReportHeader: FunctionComponent<ViewEvaluationReportHeaderProps> = props => {
    return (
        <div className={styles.container}>
            {props.onBack && (
                <Button
                    label=""
                    variant="text-green"
                    leftIcon={faArrowLeft}
                    className={styles.backButton}
                    onClick={props.onBack}
                />
            )}
            <div className={styles.titleContainer}>
                <h3 className={styles.title}>{props.title}</h3>
            </div>
            {props.onEdit && (
                <Button
                    label="Edit Results"
                    variant="black"
                    size="small"
                    onClick={props.onEdit}
                />
            )}
        </div>
    );
};
